import React from 'react'

const Floatingbutton = ({ onOpen = () => {}, label = 'Create new' }) => {
  return (
    <button
      type="button"
      className="btn bl-fab"
      onClick={() => onOpen()}
      aria-label={label}
      title={label}
    >
      <ion-icon name="add-outline" aria-hidden="true"></ion-icon>
    </button>
  )
}

export default Floatingbutton
